<template>
  <div data-grm-comp="RoomTranslation" class="room-translation-wrapper">
    <div class="room-translation-container">
      <div class="room-translation-title">
        <span>{{$t('extendMenu.translation.title')}}</span>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="room-translation-item-box">
        <ul class="room-translation-item-list">
          <li v-for="item in translationLangItems"
              :key="item.key"
              class="room-translation-item"
              @click="onEnableTranslation(item)"
          >
            <div :class="`item-icon bg-${item.key}`"/>
            <button class="item-btn">
              <span :class="item.key"></span>
              <span class="item-value">{{ $t(`extendMenu.translation.lang.${item.key}`) }}</span>
              <span class="item-lang">{{ item.lang }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";

export default {
  name: "RoomTranslation",
  components: {GrmCloseBtn},
  computed: {
    ...mapGetters('translation', ['translationState'])
  },
  data() {
    return {
      translationLangItems: [
        { key: 'KO', value: '한국어', lang: '가나다라' },
        { key: 'EN', value: '영어', lang: 'ABC' },
        { key: 'ES', value: '스페인어', lang: 'español' },
        { key: 'VI', value: '베트남어', lang: 'Tiếng Việt' },
        { key: 'JA', value: '일본어', lang: '日本語' },
        { key: 'AR', value: '아랍어', lang: 'عربي' },
        { key: 'DE', value: '독일어', lang: 'Deutsch' },
        { key: 'ZH-CN', value: '중국어(간체)', lang: '簡體字' },
        { key: 'ZH-TW', value: '중국어(번체)', lang: '繁体字' },
        { key: 'RU', value: '러시아어', lang: 'Русский' },
      ],
    }

  },
  methods: {
    ...mapActions('translation', ['enableTranslation']),

    onEnableTranslation(item) {
      let data = {
        enable: false
      }
      if (this.translationState) {
        console.warn('## already translation')
      } else {
        data.enable = true
        data.targetLang = item.key
      }
      this.enableTranslation(data);
      this.onClose()
    },
    onClose() {
      this.$modal('RoomTranslation')
    },
  },
}
</script>

<style scoped>

.room-translation-wrapper {
  display: flex;
  position: fixed;
  inset: 0;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
  flex-direction: column;

  .room-translation-container {
    background-color: white;
    width: 450px;
    max-height: 320px;
    display: flex;
    flex-direction: column;

    .room-translation-title {
      display: flex;
      font-weight: bold;
      padding: 10px 20px;
      justify-content: space-between;
    }
    .room-translation-item-box {
      overflow-y: auto;
      flex-grow: 1;
      padding: 10px 20px;
      border-radius: 10px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

      .room-translation-item-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;

        .room-translation-item {
          border-radius: 5px;
          transition: background-color 0.3s;
          display: flex;
          gap: 4px;
          width: 50%;
          &:hover {
            background-color: #f0f0f0;
          }

          .item-icon {
            min-height: 40px;
            min-width: 40px;
            border-radius: 40px;
            &.bg-AR {
              background: url('~@/assets/images/translation_AR.png') no-repeat center / 1.5rem auto;
            }
            &.bg-EN {
              background: url('~@/assets/images/translation_EN.png') no-repeat center / 1.5rem auto;
            }
            &.bg-ES {
              background: url('~@/assets/images/translation_ES.png') no-repeat center / 1.5rem auto;
            }
            &.bg-JA {
              background: url('~@/assets/images/translation_JA.png') no-repeat center / 1.5rem auto;
            }
            &.bg-KO {
              background: url('~@/assets/images/translation_KO.png') no-repeat center / 1.5rem auto;
            }
            &.bg-VI {
              background: url('~@/assets/images/translation_VI.png') no-repeat center / 1.5rem auto;
            }
            &.bg-DE {
              background: url('~@/assets/images/translation_DE.png') no-repeat center / 1.5rem auto;
            }
            &.bg-ZH-CN {
              background: url('~@/assets/images/translation_ZH-CN.png') no-repeat center / 1.5rem auto;
            }
            &.bg-ZH-TW {
              background: url('~@/assets/images/translation_ZH-TW.png') no-repeat center / 1.5rem auto;
            }
            &.bg-RU {
              background: url('~@/assets/images/translation_RU.png') no-repeat center / 1.5rem auto;
            }
          }

          .item-btn {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 10px;
            border: none;
            background-color: transparent;
            cursor: pointer;
            text-align: left;

            .item-value {
              font-weight: bold;
            }
            .item-lang {
              font-size: 12px;
              float: right;
              color: #888;
            }
          }
        }
      }

    }
  }
}
</style>